/**
 * Marks a viewer's GUI as loaded and runs every callback queued via
 * `viewer.onGUILoaded()` / `viewer.promiseGuiLoaded()` exactly once.
 *
 * The queue is swapped out before draining, so a task that registers another
 * `onGUILoaded` callback while running gets it invoked immediately (guiLoaded is
 * already true) instead of re-queuing it, and a later second "GUI loaded"
 * event (e.g. `loadGUI()` invoked twice on the same viewer) cannot replay the
 * old tasks. Before this the mobile path replayed the whole queue and then
 * also called the host callback directly, so `loadGUI(cb)` ran `cb` two or
 * three times on phones and every point cloud was added to the scene again.
 *
 * A throwing task is reported and skipped rather than aborting the drain:
 * the queue also holds the resolve() from `promiseGuiLoaded()`, so aborting
 * would leave `await viewer.loadGUI()` pending forever.
 *
 * Kept free of DOM / three.js imports so `node --test` can cover it.
 */
export function markGuiLoaded(viewer) {
  viewer.guiLoaded = true;
  const tasks = viewer.guiLoadTasks || [];
  viewer.guiLoadTasks = [];
  for (const task of tasks) {
    try {
      task();
    } catch (err) {
      console.error('[Potree] onGUILoaded callback failed:', err);
    }
  }
}
